exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mx-datepicker[data-v-2501dbf2] {\n  width: 251px !important;\n}\nlabel[data-v-2501dbf2] {\n  font-weight: 600;\n  color: black;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2501dbf2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/receivedemail/receivedemail.component.scss
// module id = 1752
// module chunks = 0